module.exports = __webpack_public_path__ + "img/groups2.dc990c50.jpg";